import React from "react";
import ProgressBar from "@ramonak/react-progress-bar";
export default function ProgressBarComp({ value }) {
  return (
    <ProgressBar
      completed={value}
      isLabelVisible={false}
      bgColor={process.env.NEXT_PUBLIC_THEME === "LT" ? "#5468ff" : "#45dabe"}
      baseBgColor={"#d8dff1"}
      animateOnRender
      height={"8px"}
    />
  );
}
